// extracted by mini-css-extract-plugin
module.exports = {"container":"TextUnread_container__hzB1t","unread":"TextUnread_unread__11_Gq","ellipse":"TextUnread_ellipse__OmiaE","questionMark":"TextUnread_questionMark__2oA_w"};